import { loadDocumentTemplates } from 'api/documents/requests';
import { loadIntegrations } from 'api/integrations/requests';
import { loadJourneyActionForms } from 'api/journey-action-forms/requests';
import { JourneyForm } from 'api/journey-forms/requests';
import { loadLists } from 'api/lists/requests';
import { request } from 'api/request';
import { JourneyType } from 'api/types';
import { loadUsers } from 'api/users/requests';

type AsyncReturnType<T extends (...args: any) => any> = Awaited<ReturnType<T>>;

type PickFromArrayReturn<F extends (...args: any) => any, K extends keyof any> = Array<
  Pick<AsyncReturnType<F>[number], Extract<K, keyof AsyncReturnType<F>[number]>>
>;

export type SearchResponse = {
  journeys: Array<Pick<JourneyType, 'shortId' | 'title' | 'workspace'>>;
  documenttemplates: PickFromArrayReturn<
    typeof loadDocumentTemplates,
    'shortId' | 'name' | 'workspace'
  >;
  journeyactionforms: PickFromArrayReturn<
    typeof loadJourneyActionForms,
    'shortId' | 'name' | 'journey'
  >;
  users: PickFromArrayReturn<
    typeof loadUsers,
    'shortId' | 'name' | 'email' | 'lastLogin' | 'picture'
  >;
  integrations: PickFromArrayReturn<typeof loadIntegrations, 'shortId' | 'name' | 'thumbnail'>;
  lists: PickFromArrayReturn<typeof loadLists, 'shortId' | 'name'>;
  journeyforms: Array<Pick<JourneyForm, 'shortId' | 'name' | 'journey' | 'workspace'>>;
};

export const loadSearch = async (searchString: string) => {
  const response = await request<SearchResponse>(
    `v1/search/?search=${encodeURIComponent(searchString)}`,
  );
  return response.data;
};
